import { call, put, takeLatest } from 'redux-saga/effects';
import {deleteNews} from "../../../services/news/news-service";
import {DELETE_NEWS_REQUEST, deleteNewsFailure, deleteNewsSuccess} from "../actions/delete-news-actions";

function* deleteNewsSaga(action) {
    try {
        yield call(deleteNews, action.payload);
        yield put(deleteNewsSuccess(action.payload));
    } catch (e) {
        yield put(deleteNewsFailure(e.message));
    }
}

export default function* watchDeleteNewsSaga() {
    yield takeLatest(DELETE_NEWS_REQUEST, deleteNewsSaga);
}